import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export interface CheckoutShippingPageContainerStyles {
    loadingOverlay?: LoadingOverlayProps;
    container?: GridContainerProps;
    headerGridItem?: GridItemProps;
    approverInfoGridItem?: GridItemProps;
    cartTotalGridItemNarrow?: GridItemProps;
    fulfillmentMethodAndAddressesGridItem?: GridItemProps;
    fulfillmentMethodAndAddressesContainer?: GridContainerProps;
    fulfillmentMethodAndNotesGridItem?: GridItemProps;
    fulfillmentMethodAndNotesContainer?: GridContainerProps;
    fulfillmentMethodGridItem?: GridItemProps;
    notesGridItemWide?: GridItemProps;
    addressesGridItem?: GridItemProps;
    notesAndCartTotalGridItem?: GridItemProps;
    notesAndCartTotalContainer?: GridContainerProps;
    notesGridItemNarrow?: GridItemProps;
    cartTotalGridItemWide?: GridItemProps;
}

export const containerStyles: CheckoutShippingPageContainerStyles = {
    loadingOverlay: {
        css: css`
            width: 100%;
        `,
    },
    headerGridItem: { width: 12 },
    approverInfoGridItem: {
        width: 12,
        css: css`
            padding: 0 15px;
        `,
    },
    cartTotalGridItemNarrow: { width: [12, 12, 0, 0, 0] },
    fulfillmentMethodAndAddressesGridItem: { width: [12, 12, 6, 8, 8] },
    fulfillmentMethodAndAddressesContainer: {
        css: css`
            > ${GridOffset} {
                width: calc(100% + 30px) !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 100% !important;
                                margin: 0;
                            `,
                            css`
                                width: 100% !important;
                                margin: 0;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
    fulfillmentMethodAndNotesGridItem: { width: 12 },
    fulfillmentMethodGridItem: { width: [12, 12, 12, 6, 6] },
    notesGridItemWide: { width: [0, 0, 0, 6, 6] },
    addressesGridItem: { width: 12 },
    notesAndCartTotalGridItem: {
        width: [12, 12, 6, 4, 4],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        min-height: 0px;
                    `,
                    css`
                        min-height: 0px;
                    `,
                    css`
                        min-height: 400px;
                    `,
                    css`
                        min-height: 400px;
                    `,
                    css`
                        min-height: 400px;
                    `,
                ])}
        `,
    },
    notesAndCartTotalContainer: {
        css: css`
            position: sticky;
            top: 110px;
        `,
    },
    notesGridItemNarrow: { width: [12, 12, 12, 0, 0] },
    cartTotalGridItemWide: { width: [0, 0, 12, 12, 12] },
    container: {
        css: css`
            margin-bottom: 30px;
            > ${GridOffset} {
                width: calc(100% + 12px);
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                width: calc(100% + 30px);
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
};

const styles = containerStyles;

const WORCheckoutShippingPageContainer = ({ id }: Props) => {
    return (
        <LoadingOverlay {...styles.loadingOverlay} loading={false}>
            <GridContainer {...styles.container}>
                <GridItem {...styles.headerGridItem}>
                    <Zone zoneName="Content0" contentId={id} />
                </GridItem>
                <GridItem {...styles.cartTotalGridItemNarrow}>
                    <Zone zoneName="Content3" contentId={id} />
                </GridItem>
                <GridItem {...styles.approverInfoGridItem}>
                    <Zone zoneName="Content5" contentId={id} />
                </GridItem>
                <GridItem {...styles.fulfillmentMethodAndAddressesGridItem}>
                    <GridContainer {...styles.fulfillmentMethodAndAddressesContainer}>
                        <GridItem {...styles.fulfillmentMethodAndNotesGridItem}>
                            <GridContainer {...styles.fulfillmentMethodAndNotesContainer}>
                                <GridItem {...styles.fulfillmentMethodGridItem}>
                                    <Zone zoneName="Content1" contentId={id} />
                                </GridItem>
                                <GridItem {...styles.notesGridItemWide}>
                                    <Zone zoneName="Content2" contentId={id} />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                        <GridItem {...styles.addressesGridItem}>
                            <Zone zoneName="Content4" contentId={id} />
                        </GridItem>
                    </GridContainer>
                </GridItem>
                <GridItem {...styles.notesAndCartTotalGridItem}>
                    <GridContainer {...styles.notesAndCartTotalContainer}>
                        <GridItem {...styles.notesGridItemNarrow}>
                            <Zone zoneName="Content2" contentId={id} />
                        </GridItem>
                        <GridItem {...styles.cartTotalGridItemWide} data-test-selector="zonename_content3">
                            <Zone zoneName="Content3" contentId={id} />
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </LoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: WORCheckoutShippingPageContainer,
    definition: {
        displayName: "WOR Page Container",
        group: "Checkout - Shipping",
    },
};

export default widgetModule;
